import type { FeatureModule } from '../types';
import taskManagementFeature from './tasks';
import workflowBuilderFeature from './workflow-builder';

export const productivityFeatures: FeatureModule[] = [taskManagementFeature, workflowBuilderFeature];
